import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import { INewsCategories } from '../../../../store/News/types';

interface NewsCategoryViewProps {
  controller: INewsCategories;
  categoryId: number | null;
  renderError(error: string): JSX.Element;
  renderLoader(): JSX.Element;
  renderCategory(value: string | undefined): JSX.Element;
}

export const NewsCategoryLoader = observer(
  ({
    controller,
    categoryId,
    renderLoader,
    renderError,
    renderCategory,
  }: NewsCategoryViewProps) => {
    useEffect(() => {
      if (controller.value || controller.isLoading) return;

      controller.load();
    }, []);

    const category = useMemo(() => {
      if (controller.isLoading || controller.error) return undefined;
      const categoryVal = controller.value?.filter((item) => {
        if (item.id === null) {
          return;
        }

        return item.id === categoryId;
      });

      return categoryVal && categoryVal[0] && categoryVal[0].name;
    }, []);

    if (controller.error) {
      return renderError(controller.error);
    }

    if (controller.isLoading) return renderLoader();

    return renderCategory(category);
  },
);
